<div class="ui-modal">
  <div class="header flex-row space-between-center">
    <span>{{ 'SUAS.ACCOUNT.DETAILS.TITLE' | translate }}</span>
    <span class="ui-icon-close c-p" matDialogClose></span>
  </div>
  <div class="body gap-16" [formGroup]="formGroup">
    <div class="flex-col gap-8">
      <label>{{ 'SUAS.ACCOUNT.DETAILS.DATE_FORMAT' | translate }}</label>
      <mat-select
        class="ui-selector ui-selector-40"
        formControlName="dateFormat"
      >
        <mat-option [value]="format.value" *ngFor="let format of dateFormat">{{
          format.name
        }}</mat-option>
      </mat-select>
    </div>
    <div class="flex-col gap-8">
      <label>{{ 'SUAS.ACCOUNT.DETAILS.HOUR_FORMAT' | translate }}</label>
      <mat-radio-group class="flex-row gap-4" formControlName="hoursFormat">
        <mat-radio-button color="primary" [value]="hourFormat.hours12">
          {{ 'SUAS.ACCOUNT.DETAILS.12HOURS' | translate }}
        </mat-radio-button>
        <mat-radio-button color="primary" [value]="hourFormat.hours24">
          {{ 'SUAS.ACCOUNT.DETAILS.24HOURS' | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="flex-col gap-8">
      <label>{{ 'SUAS.ACCOUNT.DETAILS.TIMEZONE' | translate }}</label>
      <mat-select class="ui-selector ui-selector-40" formControlName="timezone">
        <mat-option [value]="zone" *ngFor="let zone of timeZones">{{
          zone
        }}</mat-option>
      </mat-select>
    </div>
  </div>
  <div class="footer flex-row end-center gap-8">
    <ui-button
      [text]="'SUAS.COMMON.CANCEL' | translate"
      type="default"
      (clickAction)="close()"
    ></ui-button>
    <ui-button
      [text]="'SUAS.COMMON.SAVE' | translate"
      (clickAction)="save()"
    ></ui-button>
  </div>
</div>
